import thunk from 'redux-thunk';
import { createStore, applyMiddleware, combineReducers } from 'redux';

import * as reducers from './reducers';

export default createStore(
  combineReducers(reducers),
  applyMiddleware(thunk)
);
